import { FlexBox, Page } from '@dixa/lib-shared-habla';

import { DashboardHeader } from '../../components/header/dashboardHeader';
import rootStyles from '../../dashboard.view.module.scss';

export const FavoriteDashboardView = (): JSX.Element => {
  return (
    <Page>
      <Page.Head
        className={rootStyles.pageHead}
        title={<DashboardHeader dashboard="favorite" />}
      />

      <Page.Body>
        <Page.Section>
          <FlexBox flexDirection="column" gap="300" height="100%">
            TODO
          </FlexBox>
        </Page.Section>
      </Page.Body>
    </Page>
  );
};
